import { render, staticRenderFns } from "./employeePrivilege.vue?vue&type=template&id=3e05595d"
import script from "./employeePrivilege.vue?vue&type=script&lang=js"
export * from "./employeePrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports